import React from 'react';
import EdgeToolStrip from './strip';
import DrawModeStrip from './stripUpdate';
import styled from 'styled-components';
import AutoDetectConfirmationPopup from './AutoDetectConfirmationPopup';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
`;

const EdgeToolStripContainer: React.FC = () => {
	return (
		<>
			<EdgeToolStrip />
			<DrawModeStrip />

			{/* <AutoDetectConfirmationPopup/> */}
		</>
	);
};

export default EdgeToolStripContainer;